import { Database, ref, update } from 'firebase/database';

export const teachersSubjectsUpdate = async (
	database: Database,
	teacherName: string,
	subjects: string[]
): Promise<void> => {
	return update(ref(database, `teachers/${teacherName}`), { subjects });
};
